import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-input-radio',
  templateUrl: './app-input-radio.component.html',
  styleUrls: ['./app-input-radio.component.scss']
})
export class AppInputRadioComponent implements OnInit, OnChanges {
  private static count = 0;
  @Input() @Output() checked = false;
  @Input() disabled = false;
  @Input() label = '';
  @Input() size = 'md';
  @Input() outline = true;
  @Input() color = 'text-primary';
  @Input() value: any;
  @Output() modelChange = new EventEmitter();
  @Input() model: any;
  id: string;
  focus = false;

  constructor() { }

  ngOnInit() {
    this.id = 'app-input-radio-' + AppInputRadioComponent.count++;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.checked = (this.model === this.value);
  }

  change() {
  //  this.checked = (this.model === this.value);
    this.modelChange.emit(this.model);
  }

}
